import { StorageService, StorageKeys } from "@/services/Storage";

const state = {
  pageTitle: "Stay Seated",
  darkMode: StorageService.get(StorageKeys.ENABLE_DARK_MODE) == "true"
};

const getters = {
  pageTitle: state => state.pageTitle,
  darkMode: state => state.darkMode
};

const mutations = {
  setPageTitle: (state, pageTitle) => {
    state.pageTitle = pageTitle;
  },
  enableDarkMode: (state, should) => {
    state.darkMode = should;
  }
};

const actions = {
  pageTitleChange({ commit }, pageTitle) {
    commit("setPageTitle", pageTitle);
    document.title = pageTitle;
  },

  setDarkMode({ commit }, enabled) {
    commit("enableDarkMode", enabled);
    StorageService.set(StorageKeys.ENABLE_DARK_MODE, enabled);
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
